import { PlusOutlined } from '@ant-design/icons';
import { Button, Drawer, DrawerProps } from 'antd';
import { Helmet } from 'react-helmet-async';

import useAPIMutation from '../../../api/useAPIMutation';
import Form from '../../../components/Form';
import InterviewScriptTemplateForm, {
  InterviewScriptTemplateFormValues,
} from '../../../components/InterviewScriptTemplateForm';

interface AddInterviewScriptTemplateProps extends DrawerProps {
  onSuccess?: (
    data: unknown,
    variables: InterviewScriptTemplateFormValues,
    context: unknown
  ) => void | Promise<unknown>;
}

const AddInterviewScriptTemplate = ({ onSuccess, ...props }: AddInterviewScriptTemplateProps) => {
  const [form] = Form.useForm();

  const mutation = useAPIMutation(
    async (
      {
        name,
        type,
        content,
        emailCommunicationContent,
        attachments,
      }: InterviewScriptTemplateFormValues,
      api
    ) => {
      let emailCommunicationTemplate = undefined;

      if (type.includes('PRACTICAL_TECHNICAL_CASE')) {
        const configs = await api.get('/configs/tenant-configurations/');

        const attachmentIds: number[] = [];

        for (const attachment of attachments) {
          const attachmentFormData = new FormData();
          attachmentFormData.append('filename', attachment.name);
          attachmentFormData.append('file', attachment.originFileObj as File, attachment.name);
          attachmentFormData.append('mimetype', attachment.type as string);
          const attachmentResponse = await api.post('/attachments/', attachmentFormData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          attachmentIds.push(attachmentResponse.data.id);
        }

        emailCommunicationTemplate = await api.post('/email-communication-templates/', {
          name: `${name} - Modelo Case Prático ou Técnico`,
          from_name: configs.data.companyFromName,
          message: emailCommunicationContent,
          subject: 'Case prático ou técnico',
          type: 'PRACTICAL_TECHNICAL_CASE',
          attachments: attachmentIds,
          individual: false,
        });
      }

      await api.post('/interview-script-templates/', {
        name,
        type,
        content,
        ...(type.includes('PRACTICAL_TECHNICAL_CASE')
          ? { email_communication_template: emailCommunicationTemplate?.data.id }
          : {}),
      });
    },
    {
      onSuccess,
    }
  );

  return (
    <Drawer
      title="Adicionar roteiro para etapa"
      width={720}
      footer={
        <Button
          type="primary"
          htmlType="submit"
          icon={<PlusOutlined />}
          loading={mutation.isLoading}
          onClick={() => form.submit()}
        >
          Adicionar
        </Button>
      }
      destroyOnClose
      {...props}
    >
      <Helmet>
        <title>Adicionar modelo de requisição de vaga | Recrutamento e Seleção</title>
      </Helmet>
      <Form<InterviewScriptTemplateFormValues>
        form={form}
        layout="vertical"
        onFinish={async (variables) => {
          mutation.mutate(variables);
        }}
        initialValues={{
          name: '',
          type: [],
          content: '',
          emailCommunicationContent: '',
          attachments: [],
        }}
      >
        <InterviewScriptTemplateForm />
      </Form>
    </Drawer>
  );
};

export default AddInterviewScriptTemplate;
